
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.41 4.942c1.157-1.984 4.024-1.984 5.182 0l8.776 15.046c1.167 2-.276 4.512-2.591 4.512H6.223c-2.315 0-3.758-2.512-2.591-4.512l8.777-15.046z","fill":"#BF0707"}}),_c('path',{attrs:{"d":"M15.741 10.57h-1.477l.117 6.484h1.244l.116-6.484zm-.74 9.185c.489 0 .897-.395.897-.888a.898.898 0 00-.897-.885c-.494 0-.899.4-.899.885 0 .493.405.888.899.888z","fill":"#fff"}})])
          )
        }
      }
    